<template>
  <div class="CountryOptions">
    <template v-for="menu in menuList" :key="menu.menuId">
      <!-- field 4971 目前是就業勞動法的編號，而該項鏈結為 pdf -->
      <a
        v-if="menu.sysMenuLinks.length < 2"
        :href="menu.sysMenuLinks[0].menuLink"
        class="coBlock"
        target="_blank"
        :title="
          menu.fileId === 4971
            ? '[另開新視窗] ' + menu.sysMenuLinks[0].webName + '.pdf'
            : '[另開新視窗] ' + menu.sysMenuLinks[0].webName
        "
      >
        <div>
          <img :src="menu.filePath" alt="" />
        </div>
        <div>
          <h4 :style="{ fontSize: fontSize.h4 + 'em' }">
            {{ menu.nodeName }}
          </h4>
        </div>
      </a>
      <a-dropdown v-else :trigger="['click']" class="drop_down_wrapper">
        <div>
          <div>
            <img :src="menu.filePath" alt="" />
          </div>
          <div>
            <h4 :style="{ fontSize: fontSize.h4 + 'em' }">
              {{ menu.nodeName }}
            </h4>
          </div>
        </div>
        <template #overlay>
          <a-menu>
            <template v-for="link in menu.sysMenuLinks" :key="link.idx">
              <a-menu-item>
                <a
                  :href="link.menuLink"
                  target="_blank"
                  :title="
                    menu.fileId === 4971
                      ? '[另開新視窗] ' + link.webName + '.pdf'
                      : '[另開新視窗] ' + link.webName
                  "
                  :style="{ width: '100%' }"
                  >{{ link.webName }}</a
                >
              </a-menu-item>
              <a-menu-divider />
            </template>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
  </div>
</template>

<script setup>
import { inject } from "vue";
let fontSize = inject("fontSize");

defineProps({
  menuList: {
    type: Array,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.CountryOptions {
  display: flex;
  flex-wrap: wrap;
  .coBlock {
    display: flex;
    align-items: center;
    width: 24%;
    padding: 20px;
    transition: 0.1s all;
    margin: 10px 5px;
    position: relative;
    border: rgb(231, 231, 231) 3px dashed;
    &:hover {
      border: $main_color 3px dashed;
    }
    @media screen and (max-width: 1350px) {
      width: 32%;
    }
    @include xl {
      width: 31%;
    }
    @include lg {
      flex-direction: column;
      width: 31%;
      h4 {
        font-size: 1em;
      }
    }
  }
  .coBlock > div {
    padding-right: 10px;
    @include lg {
      padding: 0 0 10px 0;
    }
  }

  .drop_down_wrapper {
    width: 24%;
    margin: 10px 5px;
    padding: 20px;
    border: rgb(231, 231, 231) 3px dashed;

    &:hover {
      cursor: pointer;
    }

    @media screen and (max-width: 1350px) {
      width: 32%;
    }
    @include xl {
      width: 31%;
    }
    @include lg {
      flex-direction: column;
      width: 31%;
      h4 {
        font-size: 1em;
      }
    }

    .ant-dropdown-menu-title-content {
      width: 100%;

      a {
        width: 100%;
      }
    }
  }
}
</style>
